import { Link } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { BrandLogo, Numeric } from "@/shared/components";

export function DocsLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-surface-base">
      <header className="sticky top-0 z-20 border-b border-stroke-subtle bg-surface-raised/95 backdrop-blur">
        <div className="mx-auto flex h-14 max-w-5xl items-center justify-between px-4 sm:px-6">
          <Link to="/" className="flex items-center gap-2">
            <BrandLogo className="size-5 text-text-brand" />
            <Numeric className="text-[14px] font-bold tracking-tight">
              datalab<span className="text-text-brand">.tools</span>
            </Numeric>
          </Link>
          <div className="inline-flex items-center gap-1.5 rounded-full border border-stroke-subtle bg-surface-base px-3 py-1 text-[11px] font-medium text-text-tertiary">
            <BookOpen className="size-3.5" />
            Docs
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-5xl px-4 py-6 sm:px-6 sm:py-8">
        {children}
      </main>
    </div>
  );
}
